import { render, staticRenderFns } from "./InventoryEditDrawer.vue?vue&type=template&id=47dcaf5b&scoped=true"
import script from "./InventoryEditDrawer.vue?vue&type=script&lang=js"
export * from "./InventoryEditDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dcaf5b",
  null
  
)

export default component.exports